export function getProviderLogoUrl(provider) {
  return `https://image.tmdb.org/t/p/w200${provider.logo_path}`
}

export function getMovieProviders(movie, type = 'flatrate') {
  return movie?.justwatch?.[type] || []
}

export function getAllProviders(movies, type = 'flatrate') {
  const providerMap = new Map()
  movies.forEach((movie) => {
    const providers = getMovieProviders(movie, type)
    providers.forEach((provider) => {
      if (!providerMap.has(provider.provider_id)) {
        providerMap.set(provider.provider_id, provider)
      }
    })
  })
  return Array.from(providerMap.values()).sort((a, b) => a.display_priority - b.display_priority)
}

export function movieHasProvider(movie, providerId, type = 'flatrate') {
  const providers = getMovieProviders(movie, type)
  return providers.some((p) => p.provider_id === providerId)
}
